import { IStatusChangedAction, StatusActionType } from ".";
import { StatusType, IStatus } from "..";

/**
 * Status changed
 * 
 */
export const StatusChangedAction = (newStatus: IStatus): IStatusChangedAction => {
    switch(newStatus.type) {
        case StatusType.READY:
            return { type: StatusActionType.READY, status: newStatus };
        case StatusType.NORESULTS:
            return { type: StatusActionType.NORESULTS, status: newStatus };
        case StatusType.FETCHING:
            return { type: StatusActionType.FETCHING, status: newStatus };
        default:
            return { type: StatusActionType.ERROR, status: newStatus };
    }
}